module.exports = __webpack_public_path__ + "static/media/attach-icon.1c3247db.svg";